import { appStore } from '~/store';
const portalMiddleware = ({ error }) => {
    const portal = appStore.portal;
    if (!portal.key) {
        error({ statusCode: 404, message: 'Domain not be found' });
    }
};
export default portalMiddleware;
